import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const heroImage = "/hero-1280.webp";

const HeroSection = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          srcSet="/hero-768.webp 768w, /hero-1280.webp 1280w, /hero.webp 1600w"
          sizes="100vw"
          alt=""
          aria-hidden="true"
          {...{ fetchpriority: "high" }}
          decoding="sync"
          width="1280"
          height="1386"
          className="w-full h-full object-cover"
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-charcoal/80 via-charcoal/65 to-charcoal/50" />
      </div>



      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20">
        <div className="max-w-3xl">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-accent-light font-semibold text-base sm:text-lg mb-3 sm:mb-4"
          >
            Quality Landscaping Since Day One
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-primary-foreground leading-tight mb-4 sm:mb-6"
          >
            Professional Landscape & Irrigation Design in NWA
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-primary-foreground/90 text-base sm:text-lg md:text-xl mb-6 sm:mb-8 max-w-2xl leading-relaxed"
          >
            Family-owned and operated for over 25 years. Residential & commercial landscape design, irrigation installation, drainage services, and more — serving Bella Vista, Rogers, Bentonville, Fayetteville & surrounding areas.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-3 sm:gap-4"
          >
            <Link to="/contact" className="w-full sm:w-auto">
              <Button variant="hero" size="lg" className="group w-full text-sm sm:text-base">
                <span className="hidden sm:inline">Get a Free Estimate Today</span>
                <span className="sm:hidden">Free Estimate</span>
                <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <a href="tel:+14794649398" className="w-full sm:w-auto">
              <Button variant="heroOutline" size="lg" className="w-full text-sm sm:text-base">
                <Phone className="mr-2 h-4 w-4 sm:h-5 sm:w-5" />
                <span className="hidden sm:inline">Call Now: 479-464-9398</span>
                <span className="sm:hidden">Call: 479-464-9398</span>
              </Button>
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="mt-8 sm:mt-12 flex flex-wrap gap-3 sm:gap-6 text-primary-foreground/80 text-xs sm:text-sm"
          >
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 bg-accent rounded-full flex-shrink-0" />
              Fully Licensed & Insured
            </span>
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 bg-accent rounded-full flex-shrink-0" />
              Free Estimates
            </span>
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 bg-accent rounded-full flex-shrink-0" />
              Residential & Commercial
            </span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
